import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'year-toggle',
    templateUrl: './year-toggle.component.html',
    styleUrls: ['./year-toggle.component.scss'],
})
export class YearToggleComponent implements OnInit {
    @Input() year: string;
    @Input() color: string;
    @Input() visible: boolean;
    circleState: string;

    constructor() {}

    ngOnInit() {
        if (this.visible) {
            this.circleState = 'fas';
        } else {
            this.circleState = 'far';
        }
    }

    toggleCircle() {
        if (this.circleState == 'fas') {
            this.circleState = 'far';
        } else {
            this.circleState = 'fas';
        }
    }
}
